function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { ADD_NOTIFICATION, REMOVE_NOTIFICATION, UPDATE_NOTIFICATION } from './constants';
/**
 * Notification Reducer
 *
 * @param {function} state - Previous state
 * @param {function} action - Current action.
 *
 * @return {object} - New state
 */

var notificationReducer = function notificationReducer(state, action) {
  switch (action.type) {
    case ADD_NOTIFICATION:
      return _objectSpread(_objectSpread({}, state), {}, {
        notificationsCount: state.notificationsCount + 1,
        notifications: [].concat(_toConsumableArray(state.notifications), [{
          component: action.component,
          key: action.options.key || "notif-component-".concat(state.notificationsCount),
          options: {
            autoDismiss: action.options.autoDismiss || state.options.autoDismiss,
            autoDismissTimeout: action.options.autoDismissTimeout || state.options.autoDismissTimeout,
            pauseOnHover: action.options.pauseOnHover || state.options.pauseOnHover
          }
        }])
      });

    case REMOVE_NOTIFICATION:
      return _objectSpread(_objectSpread({}, state), {}, {
        notifications: state.notifications.filter(function (notification) {
          return notification.key !== action.key;
        })
      });

    case UPDATE_NOTIFICATION:
      return _objectSpread(_objectSpread({}, state), {}, {
        notifications: state.notifications.map(function (notification) {
          if (notification.key === action.options.key) {
            return _objectSpread(_objectSpread({}, notification), {}, {
              component: action.component,
              options: {
                autoDismiss: action.options.autoDismiss || state.options.autoDismiss,
                autoDismissTimeout: action.options.autoDismissTimeout || state.options.autoDismissTimeout,
                pauseOnHover: action.options.pauseOnHover || state.options.pauseOnHover
              }
            });
          }

          return notification;
        })
      });

    default:
      {
        throw new Error("Unhandled action type: ".concat(action.type));
      }
  }
};

export default notificationReducer;